import { BB } from '../../../bb/bb';
import { LANG } from '../../../language/language';
import { GalleryStore } from '../../storage/gallery-store';
import { GalleryUi } from '../modals/gallery-ui';
import { TKlProject } from '../../kl-types';
import { showModal } from '../modals/base/showModal';
import { KL } from '../../kl';

export class GalleryComponent {
    private readonly rootEl: HTMLElement;
    private readonly galleryStore: GalleryStore;
    private readonly getProject: () => TKlProject;
    private readonly onStored: () => void;
    private readonly onLoad: (id: string) => void;

    constructor(p: {
        galleryStore: GalleryStore;
        getProject: () => TKlProject;
        onStored: () => void;
        onLoad: (id: string) => void;
    }) {
        this.galleryStore = p.galleryStore;
        this.getProject = p.getProject;
        this.onStored = p.onStored;
        this.onLoad = p.onLoad;

        this.rootEl = BB.el({
            className: 'kl-gallery-component',
            css: {
                margin: '10px',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '5px'
            }
        });

        const header = BB.el({
            content: 'Gallery (Local)',
            css: { fontWeight: 'bold', marginBottom: '10px' }
        });

        const btnRow = BB.el({
            css: { display: 'flex', gap: '10px' }
        });

        const saveBtn = BB.el({
            tagName: 'button',
            className: 'grid-button',
            content: 'Save to Gallery',
            onClick: () => this.saveToGallery()
        });

        const openBtn = BB.el({
            tagName: 'button',
            className: 'grid-button',
            content: 'Open Gallery',
            onClick: () => this.openGallery()
        });

        BB.append(btnRow, [saveBtn, openBtn]);
        BB.append(this.rootEl, [header, btnRow]);
    }

    async saveToGallery() {
        const project = this.getProject();
        const projectName = prompt('Enter a name for this project:', 'Untitled');
        if (projectName === null) {
            return; // Cancelled
        }
        try {
            await this.galleryStore.store(project, projectName);
            this.onStored();
            KL.popup({
                target: document.body,
                message: 'Saved to Gallery as "' + projectName + '"',
                type: 'ok'
            });
        } catch (e) {
            KL.popup({
                target: document.body,
                message: 'Failed to save',
                type: 'error'
            });
            console.error(e);
        }
    }

    openGallery() {
        new GalleryUi({
            galleryStore: this.galleryStore,
            onLoad: (id) => {
                this.onLoad(id);
            }
        });
    }

    getElement(): HTMLElement {
        return this.rootEl;
    }
}
